export default __webpack_public_path__ + "static/media/Boots of the Dauntless.2b746987.jpg";